var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 31.0175H12.5C5.26002 31.0175 2.16669 27.9242 2.16669 20.6842V12.6842C2.16669 5.44416 5.26002 2.35083 12.5 2.35083H20.5C27.74 2.35083 30.8334 5.44416 30.8334 12.6842V20.6842C30.8334 27.9242 27.74 31.0175 20.5 31.0175ZM12.5 4.35083C6.35335 4.35083 4.16669 6.5375 4.16669 12.6842V20.6842C4.16669 26.8308 6.35335 29.0175 12.5 29.0175H20.5C26.6467 29.0175 28.8334 26.8308 28.8334 20.6842V12.6842C28.8334 6.5375 26.6467 4.35083 20.5 4.35083H12.5Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2067 19.6308C20.9534 19.6308 20.7 19.5375 20.5 19.3375L16.5 15.3375L12.5 19.3375C12.1134 19.7242 11.4734 19.7242 11.0867 19.3375C10.7 18.9508 10.7 18.3108 11.0867 17.9242L15.7934 13.2175C16.18 12.8308 16.82 12.8308 17.2067 13.2175L21.9134 17.9242C22.3 18.3108 22.3 18.9508 21.9134 19.3375C21.7134 19.5375 21.46 19.6308 21.2067 19.6308Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveUp);
export default __webpack_public_path__ + "static/media/move-up.01a5ff2a3f96a20885c57548181031bc.svg";
export { ForwardRef as ReactComponent };